import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  autocomplete: {
    flex: 1,
  },
};

export default styles;
